<template>
  <div class="h-100">
  <div class="h-100">
   <div class="d-inline-flex w-100" style="height:50px">
        <div class="justify-content-start">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb comm-settings-top-nav m-0">
                  <li class="comm-icon-rtl">
                     <back-button  v-on:click.native="changeComponent('show-user')"></back-button>
                  </li>
                </ol>
            </nav>
        </div>
    </div>
    <nav class="navbar navbar-expand-lg p-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
             <div class="navbar-nav w-100 top-nav-bar">
                <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'users-info';" :class='(selectedUserComponent === "users-info")?"active":"inactive"'>{{$t('Basic Info')}}<span class="sr-only">(current)</span></a>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'users-privileges'" :class='(selectedUserComponent === "users-privileges")?"active":"inactive"'>{{$t('Privileges')}}</a>
                <template v-if="selectedUserType.type != 'SystemAdmin'">
                  <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'bins-permissions'" :class='(selectedUserComponent === "bins-permissions")?"active":"inactive"'>{{$t('Bin Permissions')}}</a>
                  <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'catalog-permissions'" :class='(selectedUserComponent === "catalog-permissions")?"active":"inactive"'>{{$t('Catalog Permissions')}}</a>
                </template>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'configure-retrieve'" :class='(selectedUserComponent === "configure-retrieve")?"active":"inactive"'>{{$t('Retrieval Settings')}}</a>
            </div>
        </div>
    </nav>
    <div style="overflow: auto; height: calc(100% - 150px)" v-if="selectedUserComponent == 'users-info'">
      <table class="table users-basic-info-table table-with-border table-scroll small-first-col" style="background: transparent">
        <thead style="color: #eee">
          <tr>
            <th scope="col" style="width: 20%"></th>
            <th scope="col" style="width: 80%"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="key-div">{{$t('Username')}}</td>
            <td class="value-div m-0">
              <div style="display:grid !important">
                <input
                  type="text"
                  id="userName"
                  class="rounded text-light comm-input-field-style"
                  v-model="userInfo.username"
                  autocomplete="off"
                  tabindex="1"
                  :placeholder="$t('Enter username')"
                />
                <span class="config-desc">{{$t('Is unique ID for the User and its non editable once it created')}}.</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('Password')}}</td>
            <td class="value-div">
              <div class="w-100" style="position: relative;display: grid">
                <div>
                <input
                  :type="passwordFieldType"
                  @input="validPasswordCheck"
                  id="password"
                  class="rounded text-light comm-input-field-style"
                  v-model="userInfo.password"
                  style="padding-inline-end: 4%"
                  tabindex="3"
                  autocomplete="off"
                  :placeholder="$t('Enter password')"
                />
                <svg
                  width="2em"
                  height="1.5em"
                  @click="switchVisibility"
                  type="password"
                  viewBox="0 0 16 16"
                  class="bi bi-eye ml-1 unhide-password"
                  style="position: relative; inset-inline-start :-4%; bottom: -6px"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                  />
                </svg>
                </div>
              <span v-show="!validPassword" class="pt-1 validationmessage"
                >
                <template v-if="!isPasswordEnforced()">
                                {{$t('Empty Password')}}
                              </template>
                              <template v-else>
                                {{$t('Password Must be 8 characters with 1Uppercase, 1Lowercase, 1Numeric & 1Special char')}}
                              </template>
                </span
              >
              </div>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('Verify Password')}}</td>
            <td class="value-div">
              <div class="w-100" style="position: relative;display: grid">
                <div>
                <input
                  :type="verifypasswordFieldType"
                  @input="passwordVerificationCheck"
                  id="verifyPassword"
                  class="rounded text-light comm-input-field-style"
                  v-model="verifiedPassword"
                  style="padding-inline-end: 4%"
                  tabindex="4"
                  autocomplete="off"
                  :placeholder="$t('Enter password again')"
                />
                <svg
                  width="2em"
                  height="1.5em"
                  @click="switchVisibilityVerifyPassword"
                  type="password"
                  viewBox="0 0 16 16"
                  class="bi bi-eye ml-1 unhide-password"
                  style="position: relative; inset-inline-start :-4%; bottom: -6px"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                  />
                </svg>
                </div>
                <span v-show="!matchedPassword" class="pt-1 validationmessage"
                >{{$t('Passwords are not matching')}}!!</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('User type')}}</td>
            <td class="value-div d-flex m-0">
              <Multiselect
                :value="selectedUserType.label"
                :options="userTypes"
                :searchable="false"
                :close-on-select="true"
                :allow-empty="false"
                @select="enableTabsByUserType($event)"
                :label="label"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                :placeholder="$t('Select Field Type')"
                :track-by="type">
                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                  <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                </div>
              </Multiselect>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('Email Id')}}</td>
            <td class="value-div">
              <div style="display: grid">
                <input
                  type="email"
                  @input="validEmailCheck"
                  id="verifyEmail"
                  class="rounded text-light comm-input-field-style"
                  v-model="userInfo.email"
                  autocomplete="off"
                  tabindex="5"
                  :placeholder="$t('Enter Email Id')"
                />
                <span v-show="!validEmail && userInfo.email.length > 0" class="pt-1 validationmessage"
                  >{{$t('Invalid email address')}}</span
                >
              </div>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('Contact Number')}}</td>
            <td class="value-div">
              <div style="display: grid">
                <input
                  type="text"
                  id="verifyContactNumber"
                  @input="validContactNumberCheck"
                  class="rounded text-light comm-input-field-style"
                  v-model="userInfo.contact_number"
                  autocomplete="off"
                  tabindex="6"
                  :placeholder="$t('Enter contact number')"
                />
                <span v-show="!validNumber && userInfo.contact_number.length > 0" class="pt-1 validationmessage"
                  >{{$t('Invalid contact number')}}</span
                >
              </div>
            </td>
          </tr>
          <tr v-if="globalSettingsFromStartup.enable_department && selectedUserType.type != 'SystemAdmin'" >
            <td class="key-div">{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</td>
            <td class="value-div d-flex m-0" style="display:flex !important;flex-direction:column;width:100%">
              <departmentsCommonComponent :isMultiselectDropdown='true' :selectedProject="selectedDepartments" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
              <span @click="openManageDepartment = true" class="manage-department-styles">{{$t('Manage')}} {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</span>
            </td>
          </tr>
          <tr>
            <td class="key-div">{{$t('Group')}}</td>
            <td class="value-div">
              <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;float:inline-start">
                <div v-on:click="enableUserGroupBrowser()" style="width: 100px; padding: 5px; margin-bottom: 8px; position: relative;text-align:center">
                  <div class="add-user-icon-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                      <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                    </svg>
                  </div>
                  <div>{{$t('Add to group')}}</div>
                </div>
                <div v-for="groupInfo in selectedGroupIdNameList" :key="groupInfo._id" class="comm-tags-class" style="width: 100px; padding: 5px; margin-bottom: 8px; position: relative;text-align:center">
                    <!-- <div class="icons-with-text-wrapper"> -->
                      <div class="user-name-or-image user-name" :style="style(groupInfo.group_name)">{{ groupInfo.group_name.split("")[0] }}
                      </div>
                        <!-- </div> -->
                        <div style="text-align:center;word-break: break-all;">{{groupInfo.group_name}}</div>
                      <cancel-icon class="delete-user-icon" @click.native="toggleSelectedGroupInList(groupInfo._id)"></cancel-icon>
                    </div>
                </div> 
            </td>
          </tr>
          <!-- <tr>
          <td class="key-div">Group</td>
          <td class="value-div" ><select class="rounded text-light comm-input-field-style" style="height:25px;">
            <option>admin</option>
            <option>developers</option>
            <option>QA</option>
            </select></td>
        </tr> -->
        </tbody>
      </table>
    </div>
    <users-privileges v-show="selectedUserComponent == 'users-privileges'" v-bind="currentProperties" :userType="selectedUserType.type" :newUser=true ref="newUserPrivilege"></users-privileges>
    <bin-permissions v-show="selectedUserComponent == 'bins-permissions'" v-bind="currentProperties" :newUser=true ref="newUserBinPermission"></bin-permissions>
    <catalog-permissions v-show="selectedUserComponent == 'catalog-permissions'" v-bind="currentProperties" :newUser=true ref="newUserCatalogPermission"></catalog-permissions>
    <configure-retrieve v-show="selectedUserComponent == 'configure-retrieve'" v-bind="currentProperties" :newUser=true ref="newRetrievalSettings"></configure-retrieve>
    <div class="primary-btn-style">
      <button
        @click="addUser(userInfo)"
        class="btn btn-outline-primary"
        data-v-198e7d7f=""
        style="position: relative; float: inline-end; inset-inline-start:0px"
      >
        {{$t('Save')}}
      </button>
      <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeComponent('show-user')">{{$t('Cancel')}}</button>
    </div>
  </div>
  <ManageDepartments v-if="openManageDepartment" @close="openManageDepartment = false"></ManageDepartments>
  <browse-user-groups v-if="userGroupBrowser" :newUser="true" :selectedUGIdNameList="selectedGroupIdNameList" @close="updateUserGroups"></browse-user-groups>
</div>
</template>

<script>
import { mapActions } from "vuex";
import Multiselect from 'vue-multiselect';
import Utils from "../../components.utils.js";
import UserPrivileges from "../users/UserPrivileges.vue";
import BinPermissions from "../users/BinsPermissions.vue"
import CatalogPermissions from "../users/CatalogPermissions.vue"
import RetrieveSettings from "../users/ConfigureRetrieve.vue"
import BackButton from "../core/backButton.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import BrowseGroups from "../userGroups/BrowseUserGroups.vue"
import ManageDepartments from "./ManageDepartments.vue";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";

export default {
  components:{
    "Multiselect":Multiselect,
    "users-privileges": UserPrivileges,
    "bin-permissions": BinPermissions,
    "catalog-permissions": CatalogPermissions,
    "configure-retrieve":RetrieveSettings,
    "back-button":BackButton,
    "cancel-icon": CancelIcon,
    "browse-user-groups": BrowseGroups,
    ManageDepartments,
    departmentsCommonComponent
  },
  data() {
    return {
      userGroupBrowser: false,
      selectedGroupIdNameList:[],
      selectedUserType:{label:"System User",type:"SystemUser"},
      userTypes:[
        {label:"System User",type:"SystemUser"},
        {label:"System Administrator",type:"SystemAdmin"},
        {label:"Customer",type:"Client"},
      ],
      userInfo: {},
      password: "",
      passwordFieldType: "password",
      verifypasswordFieldType: "password",
      selectedUserComponent:'users-info',
      validPassword: true,
      validEmail: true,
      validNumber: true,
      verifiedPassword: "",
      newUserData:{},
      matchedPassword: true,
      emailRegex: new RegExp(
        /^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/
      ),
      passwordRegex: new RegExp(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
      ),
      // eslint-disable-next-line no-useless-escape
      contactNumber: new RegExp(/(^\+[\d]{2}[\d]{10})|(^[\d]{10}$)|(^[\d]{3}[\-]{1}[\d]{8}$)/),
      openManageDepartment:false,
      departmentsList:[],
      selectedDepartments:null
    };
  },
  emits: ["changeSelectedComponent"],
  computed:{
      globalSettingsFromStartup:{
        get(){
          return this.$store.state.startUpData.startUpDataDetails;
        }
      },
       currentProperties() {
      //Dynamically send props
      if (this.selectedUserComponent === "users-privileges" ||this.selectedUserComponent === "bins-permissions" || this.selectedUserComponent === "catalog-permissions") {
        return { selectedUserID: this.newUserData._id };
      } else {
        return {};
      }
    },
  },
  methods: {
    updateSelectedDepartments(values){
      this.selectedDepartments = values;
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    updateUserGroups(groupInfo){
      this.selectedGroupIdNameList = groupInfo
      this.userGroupBrowser = false
    },
    enableUserGroupBrowser(){
      this.userGroupBrowser = true
    },
    toggleSelectedGroupInList(gorupId){
      this.selectedGroupIdNameList = this.selectedGroupIdNameList.filter(op=>op._id != gorupId)
    },
    enableTabsByUserType(userType){
      this.selectedUserType.label = userType.label;
      this.selectedUserType.type = userType.type;
    },
    ...mapActions("users", ["addNewUser"]),
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    switchVisibilityVerifyPassword() {
      this.verifypasswordFieldType =
        this.verifypasswordFieldType === "password" ? "text" : "password";
    },
    isPasswordEnforced(){
      return JSON.parse(Utils.getLocalStorageValue('enable_password_enforcement'))
    },
    validPasswordCheck() {
      if(this.isPasswordEnforced()){
      if (
        this.userInfo.password.length != 0 &&
        this.passwordRegex.exec(this.userInfo.password) != null
      ) {
        this.validPassword = true;
        this.passwordVerificationCheck();
      } else {
        this.validPassword = false;
      }
      }else if(this.userInfo.password.trim().length > 0){
        this.validPassword = true
        this.passwordVerificationCheck();
      }else{
        this.validPassword = false
      }
    },
     changeComponent(comp){
            this.$emit("changeSelectedComponent", comp);
            let enableAddGroupButton = false
            if(this.tableType == 'show-user-groups'){
                    this.$emit("changeSelectedComponent",comp)
                    this.$refs.userGroupRef.changeSelectedComponent(comp)
                if(comp == "show-user-groups"){
                    enableAddGroupButton = true
                }else if(comp == "user-group-info"){
                    enableAddGroupButton = true
                }
            }
            this.showUserGroupAddButton = enableAddGroupButton
      },
    passwordVerificationCheck() {
      if (
        this.verifiedPassword == this.userInfo.password &&
        this.verifiedPassword.length != 0
      ) {
        this.matchedPassword = true;
      } else {
        this.matchedPassword = false;
      }
    },
    validEmailCheck() {
      if (
        (this.userInfo.email.length != 0 &&
          this.emailRegex.exec(this.userInfo.email) != null)
      ) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
     validContactNumberCheck() {
      if (
        this.userInfo.contact_number.length != 0 &&  this.contactNumber.exec(this.userInfo.contact_number) != null
      ) {
        this.validNumber = true;
      } else {
        this.validNumber = false;
      }
    },
    getOnlyIdsArr(arrayOfDictionaries){
        return arrayOfDictionaries.map(item => item._id);
    },
    addUser(userInfo) {
      if (
        typeof this.userInfo.username == "undefined" ||
        this.userInfo.username.trim().length <= 0
      ) {
        alert("Please add valid username. ");
        document.getElementById("userName").focus();
        return;
      }
      if (
        typeof this.userInfo.password == "undefined" ||
        this.userInfo.password.length <= 0 ||
        !this.validPassword
      ) {
        alert("Please add a valid password. ");
        document.getElementById("password").focus();
        return;
      }
      if (
        typeof this.verifiedPassword == "undefined" ||
        this.verifiedPassword.length <= 0
      ) {
        alert("Passwords are not matching.");
        document.getElementById("verifyPassword").focus();
        return;
      }
      // if (!this.validEmail ||
      //   !Object.keys(this.userInfo).includes('email') ||
      //   typeof this.userInfo.email == "undefined") {
      //   alert("Please add a valid email address. ");
      //   document.getElementById("verifyEmail").focus();
      //   return;
      // }
      // if(!this.validNumber ||
      //   !Object.keys(this.userInfo).includes('contact_number') ||
      //   typeof this.userInfo.contact_number == "undefined"){
      //   alert("Please add a valid contact number. ")
      //   document.getElementById("verifyContactNumber").focus();
      //   return;
      // }
      userInfo.access_control = {
        privileges : this.$refs.newUserPrivilege.getUserPrivileges(),
        bins: this.$refs.newUserBinPermission.getUserBinPermissions(),
        catalogs: this.$refs.newUserCatalogPermission.getUserCatPermissions(),
        retrieval: this.$refs.newRetrievalSettings.getUserRetrieval(),
      }
      if(userInfo.access_control.retrieval.retrieval_type == "user"){
            if(userInfo.access_control.retrieval.path == undefined){
              alert("Select retrieve path.");
              return false;
            }
          }
      userInfo.user_type = this.selectedUserType.type;
      if(this.selectedDepartments && this.selectedDepartments.length > 0)userInfo.department = this.getOnlyIdsArr(this.selectedDepartments);
      this.addNewUser(userInfo).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          this.$toast.success(data.message);
          this.newUserData = data;
          if(this.selectedGroupIdNameList && Array.isArray(this.selectedGroupIdNameList) && this.selectedGroupIdNameList.length >0){
            let failedUserGroups = []
            for(let eachUG of this.selectedGroupIdNameList){
              let payload = {}
              let userIdList = eachUG.user_list;
              userIdList.push(this.newUserData._id)
              payload["params"] = { _id: eachUG._id};
              payload["user_list"] = userIdList;
              this.updateExistingUserGroup(payload).then((uGdata) => {
                if(!Utils.isAcceptedStatusCode(uGdata.statusCode)){
                  failedUserGroups.append(eachUG.group_name)
                }
              })
            }
            if(failedUserGroups && failedUserGroups.length > 0){
              this.$toast.error(`Failed to add user in "${failedUserGroups.join(',')}" group(s).`)
            }
          }
          this.$emit("changeSelectedComponent", "show-user");
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    ...mapActions("userGroups", ["updateExistingUserGroup"]),
    ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo","deleteDepartment"]),
  },
  mounted(){
    document.getElementById("userName").focus();
  },
  created(){
    this.getDepartments().then((data) => {
      this.departmentsList = data.department;
    }) 
  }
};
</script>

<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $button-height:38px;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;

::v-deep {
.multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
      border: $border-color !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: 12px !important;
      width:35%;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
    }
}


.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
      line-height:41px;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}
.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  bottom: 6px;
  inset-inline-end: 0%;
  height:50px;
  background: $primary-background;
  width:100%;
  z-index:9;
  button {
    height: $button-height;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    margin-inline-end:15px;
  }
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size:15px;
}
.top-nav-bar{
    background: $primary-background;
}
.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items: center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}
.comm-input-field-style{
    background: $primary-background!important;
    width: 35% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.unhide-password{
  color:$dull-text-color !important;
}

.unhide-password:hover{
  color:$text-color !important;
}

.config-desc{
  color: $dull-text-color;
  font-size: 15px;
  margin-top: 1px;
}

.add-user-icon-wrapper{
    height: 57px;
    width: 60px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color;
    top:-3px; 
    svg{
      color: $add-button-text-color !important;
      margin: 0px auto;
      width: 100%;
      position: relative;
      // top: -6px;
    }
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 17px;
  top: -2px;
  height: 23px;
  width: 23px;
  border: $border-color;
  background: $primary-background;
  border-radius: 30px;
  color: $text-color;
}
.delete-user-icon{
  visibility: hidden;
}
.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}
.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}
.icons-with-text-wrapper{
    height: 45px;
    width: 45px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    border: $border-color;
    svg{
      margin: 0px auto;
      width: 100%;
      position: relative;
      top: -6px;
    }
}
.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
    height:40px;
    }
  }
}

.user-name-or-image{
    // height: 30px;
    // width: 30px;
    // border: $border-color;
    // border-radius: 10px;
    // text-align: center;
    // line-height: 28px;
    // text-transform: uppercase;
    // margin-top: 3px;
    // top:4px !important;
    height: 60px;
    width: 60px;
    border: 1px solid #4a4a4a;
    border-radius: 10px;
    text-align: center;
    text-transform: uppercase;
    margin: 0 auto !important;
    font-size: 28px;
    line-height: 60px;
}
.user-name{
    margin-inline-end: 10px;
    position: relative;
    // bottom: 7px;
}

.manage-department-styles{
  float: inline-start;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  color: #909b43cf;
  width: 35%;
  text-align: end;
}

.manage-department-styles:hover{
  text-decoration: underline;
}


</style>